import { Description } from './Description';

export { useDescriptionRenderer } from './hooks';

export default Description;
